/**
 * Category data for Shop by Category section
 */
import { ProductCategory, ProductCategoryLabels } from '@/types';

export interface CategoryData {
  id: string;
  name: string;
  slug: string;
  description: string;
  image: string;
  icon: string;
  productCount: number;
  color: string;
  isActive: boolean;
}

export const categories: CategoryData[] = [
  {
    id: ProductCategory.HANDPIECES,
    name: ProductCategoryLabels[ProductCategory.HANDPIECES],
    slug: 'handpieces',
    description: 'High & low speed dental handpieces',
    image: '/images/categories/handpieces.jpg',
    icon: '🔧',
    productCount: 6,
    color: '#0077B6',
    isActive: true,
  },
  {
    id: ProductCategory.ENDODONTIC,
    name: ProductCategoryLabels[ProductCategory.ENDODONTIC],
    slug: 'endodontic',
    description: 'Rotary files, hand files & more',
    image: '/images/categories/endodontic.jpg',
    icon: '📍',
    productCount: 4,
    color: '#00B4D8',
    isActive: true,
  },
  {
    id: ProductCategory.STERILIZATION,
    name: ProductCategoryLabels[ProductCategory.STERILIZATION],
    slug: 'sterilization',
    description: 'Autoclaves, UV chambers & sterilizers',
    image: '/images/categories/sterilization.jpg',
    icon: '🧪',
    productCount: 5,
    color: '#10B981',
    isActive: true,
  },
  {
    id: ProductCategory.IMPLANT,
    name: ProductCategoryLabels[ProductCategory.IMPLANT],
    slug: 'implant',
    description: 'Implant kits & accessories',
    image: '/images/categories/implant.jpg',
    icon: '🦷',
    productCount: 3,
    color: '#8B5CF6',
    isActive: true,
  },
  {
    id: ProductCategory.HYGIENE_DISPOSABLE,
    name: ProductCategoryLabels[ProductCategory.HYGIENE_DISPOSABLE],
    slug: 'hygiene-disposable',
    description: 'Masks, bibs, caps & cotton rolls',
    image: '/images/categories/hygiene.jpg',
    icon: '🧤',
    productCount: 8,
    color: '#F59E0B',
    isActive: true,
  },
  {
    id: ProductCategory.BURS,
    name: ProductCategoryLabels[ProductCategory.BURS],
    slug: 'burs',
    description: 'Diamond & carbide burs',
    image: '/images/categories/burs.jpg',
    icon: '💎',
    productCount: 1,
    color: '#EF4444',
    isActive: true,
  },
  {
    id: ProductCategory.CROWNS,
    name: ProductCategoryLabels[ProductCategory.CROWNS],
    slug: 'crowns',
    description: 'Pediatric stainless steel crowns',
    image: '/images/categories/crowns.jpg',
    icon: '👑',
    productCount: 1,
    color: '#EC4899',
    isActive: true,
  },
  {
    id: ProductCategory.IMPRESSION,
    name: ProductCategoryLabels[ProductCategory.IMPRESSION],
    slug: 'impression',
    description: 'Mixing bowls, spatulas & trays',
    image: '/images/categories/impression.jpg',
    icon: '🎨',
    productCount: 3,
    color: '#14B8A6',
    isActive: true,
  },
  {
    id: ProductCategory.INSTRUMENT_TRAY,
    name: ProductCategoryLabels[ProductCategory.INSTRUMENT_TRAY],
    slug: 'instrument-tray',
    description: 'Trays & organizers for instruments',
    image: '/images/categories/organizer.jpg',
    icon: '📦',
    productCount: 3,
    color: '#6366F1',
    isActive: true,
  },
  {
    id: ProductCategory.SUCTION_TIPS,
    name: ProductCategoryLabels[ProductCategory.SUCTION_TIPS],
    slug: 'suction-tips',
    description: 'Evacuation & suction tips',
    image: '/images/categories/suction.jpg',
    icon: '💨',
    productCount: 1,
    color: '#84CC16',
    isActive: true,
  },
  {
    id: ProductCategory.WATER_FLOSSER,
    name: ProductCategoryLabels[ProductCategory.WATER_FLOSSER],
    slug: 'water-flosser',
    description: 'Portable water flossers',
    image: '/images/categories/water-flosser.jpg',
    icon: '💧',
    productCount: 1,
    color: '#06B6D4',
    isActive: true,
  },
  {
    id: ProductCategory.RETAINER_BOX,
    name: 'Safe Keepers',
    slug: 'safe-keepers',
    description: 'Retainer & denture boxes',
    image: '/images/categories/safe-keepers.jpg',
    icon: '📦',
    productCount: 2,
    color: '#A855F7',
    isActive: true,
  },
  {
    id: ProductCategory.PEDODONTICS,
    name: ProductCategoryLabels[ProductCategory.PEDODONTICS],
    slug: 'pedodontics',
    description: 'Pediatric dental equipment & instruments',
    image: '/images/categories/pedodontics.jpg',
    icon: '👶',
    productCount: 4,
    color: '#F472B6',
    isActive: true,
  },
  {
    id: ProductCategory.DISPOSABLES,
    name: ProductCategoryLabels[ProductCategory.DISPOSABLES],
    slug: 'disposables',
    description: 'Masks, cotton rolls & suction tips',
    image: '/images/categories/disposables.jpg',
    icon: '🧻',
    productCount: 3,
    color: '#78716C',
    isActive: true,
  },
];

// Get category by slug
export const getCategoryBySlug = (slug: string): CategoryData | undefined => {
  return categories.find(c => c.slug === slug);
};

// Get category by ID
export const getCategoryById = (id: string): CategoryData | undefined => {
  return categories.find(c => c.id === id);
};
